import React from 'react';
import { Select } from 'antd';
import { useAppState } from 'providers/AppState';
import appConfig from 'app.config';
const { Option } = Select;

const SelectorLanguages = () => {
  const { setLocale, locale } = useAppState();
  return (
    <Select
      defaultValue={locale.toUpperCase()}
      style={{ width: 120 }}
      onChange={setLocale}
      value={locale || 'en'}
    >
      {appConfig.langs.map(lang => (
        <Option key={lang} value={lang}>
          {lang.toUpperCase()}
        </Option>
      ))}
    </Select>
  );
};

export default SelectorLanguages;
